// extracted by mini-css-extract-plugin
module.exports = {"label":"_1sm4P","color-sample":"UZE8T","colorSample":"UZE8T","disabled":"_3IbCb","input":"_1-wlP"};